import UiPageListSearch from "./UiPageListSearch";
import UiPageListSearch_DynamicSearchItem from "./UiPageListSearch_DynamicSearchItem";
import { EnumUiDynamicSearchItemType } from "./EnumUiDynamicSearchItemType";
import { EnumCompare } from "./EnumCompare";

/**
 * 基础价格表-列分页列表-搜索条件分页列表-搜索条件
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListSearchPriceTableColumn extends UiPageListSearch {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 价格表Id
     */
    TableId?: string;
    /**
     * 在基准/结算/指导/协议价中显示
     */
    ShowBSGA?: boolean;
    /**
     * 在成本中显示
     */
    ShowCost?: boolean;
}

/**
 * 基础价格表-列分页列表-搜索条件分页列表-搜索条件-表单校验
 */
export const DtoPageListSearchPriceTableColumnRules = {
}

/**
 * 基础价格表-列分页列表-搜索条件分页列表-搜索条件-动态搜索配置项
 */
export const DtoPageListSearchPriceTableColumnDynamicSearchItems: UiPageListSearch_DynamicSearchItem[]  = [
]
